/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Ip from './modules/ip';
import InfoBox from './modules/info-box';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'ip':

                        let ipInstance = new Ip(item);

                        ipInstance.init();

                        break;
                    
                    case 'info-box':

                        let infoBoxInstance = new InfoBox(item);

                        infoBoxInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {

    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    }
};

// Launch
app.init();
